import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class PresetValidator {

    name = [
        Validators.required
    ];

    type = [
        Validators.required
    ]

    attribute_id = [
        Validators.required
    ];

    attribute_group_id = [
        Validators.required
    ];

    attribute_value_type = [
        Validators.required
    ]

    attr_present_type_id = [
        Validators.required
    ]

    attribute_value = [
        Validators.required
    ]

    // Error messages
    errorMessages = {
        
        name: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],

        type: [
            {
                type: 'required',
                message: 'MEGGAGES.REQUIRED_FIELD',
                options: null
            }
        ],

        attribute_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        attribute_group_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            },

            {
                type: 'pattern',
                message: 'MESSAGES.ONLY_ENG_ALLOWED',
                option: null
            }
        ],

        attribute_value_type: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],

        attr_present_type_id: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],

        attribute_value: [
            {
                type: 'required', 
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
    }
}